/**
 * RESPONSIBILITY: draw a ministry's bands down its page, each as the template it was given.
 *
 * Content in, markup out. The bands are rows - see MinistryBand - so nothing here reads the
 * rendered HTML back to work out where a picture was or where a section began.
 *
 * THE TINT ALTERNATES BY POSITION among the bands actually drawn, so an editor changes the
 * rhythm by dragging a row, and a band that has nothing to show never leaves two of the
 * same colour side by side. That is why each template is asked `has()` first, here, and not
 * left to draw nothing for itself.
 *
 * A band switched off is not drawn, for anybody. Unlike a ministry, which is scattered
 * across Home and the index, a band exists only here - and the switch that turned it off is
 * one row of the list the pencil on this page opens, so it cannot be lost.
 */
import { idOf } from '@framework/core';
import type { MinistryBand } from '@app/sections';
import { isShown } from '../commons/shown';
import { bandOf } from './bands/bands';

export function MinistryBody({ bands }: { bands: MinistryBand[] | undefined }) {
  const rows = (bands ?? []).filter((b) => isShown(b) && bandOf(b)?.has(b));
  if (rows.length === 0) return null;

  return (
    <>
      {rows.map((band, i) => {
        const Draw = bandOf(band)!.Draw;
        return <Draw b={band} tinted={i % 2 === 0} key={idOf(band) || i} />;
      })}
    </>
  );
}
